module.exports = __webpack_public_path__ + "static/img/step3.28828d3.png";


//////////////////
// WEBPACK FOOTER
// ./static/funding_cpunk/creation/step3.png
// module id = pVz3
// module chunks = 1